import PropTypes from 'prop-types';

import { trackEvent } from 'dibs-tracking';
import { Link } from 'dibs-elements/exports/Link';

import styles from './ContemporaryLandingMakerRowItem.scss';

const trackClick = () => {
    trackEvent({
        action: 'featured sellers',
        category: 'contemporary landing page interaction',
        label: 'maker clicked',
    });
};

export const ContemporaryLandingMakerRowItem = ({ item }) => {
    if (!item) {
        return null;
    }

    return (
        <div className="colXs6 colLg3">
            <div className={styles.wrapper}>
                <Link href={item.url} className={styles.imageLink} onClick={trackClick}>
                    {item.imagePath ? (
                        <img className={styles.image} src={item.imagePath} alt={item.name} />
                    ) : (
                        <div className={styles.placeholder} />
                    )}
                </Link>
                <div className={styles.name}>
                    <Link className={styles.nameLink} href={item.url} onClick={trackClick}>
                        {item.text}
                    </Link>
                </div>
            </div>
        </div>
    );
};

ContemporaryLandingMakerRowItem.propTypes = {
    item: PropTypes.object,
};
